<template lang="html">
    <div id="page__forward-search" class="toolbar-search">
        <input type="text" placeholder="Наименование/ОКАТО/ФИАС..." v-model="filter.search"  class="toolbar-search__input" v-on:keyup.enter="onFilter" />
        <z-icon-button v-bind:icon="['fa', 'xmark']" rounded danger-light v-bind:disabled="!hasFilter" v-on:click="onReset"></z-icon-button>
    </div>
</template>
<script>
    import ZIconButton from '@/components/ZIconButton.vue';
    export default {
        components: { ZIconButton },
        data() {
            return {
                filter: {
                    search: null,
                },
                filterDefault: {
                    search: null
                }
            }
        },
        computed: {
            hasFilter() {
                return Object.values(this.filter).some(item => !!item);
            },
        },
        watch: {
            'filter.search'(val) {
                const search = val;
                setTimeout(() => {
                    if (!this.filter.search || !this.filter.search) return this.onReset();
                    if (this.filter.search == search) this.onFilter();
                }, 1000)
            }
        },
        created() {
            this.resolveQueryFilter();
        },
        methods: {
            /**
             * Подставление фильтра при перезагрузки
             */
            resolveQueryFilter() {
                if (!this.$route.query || !this.$route.query.filter) return
                this.filter = Object.assign({}, JSON.parse(this.$route.query.filter))
            },
            /**
             * ФИльтрация
             */
            onFilter() {
                this.$router.push({
                    name: this.$route.name,
                    params: this.$route.params,
                    query: {
                        filter: JSON.stringify(this.filter)
                    }
                });
                this.$root.$emit('refresh-table', 'cities');
            },
            /**
             * Сброс фильтра
             */
            onReset() {
                this.filter = Object.assign({}, this.filterDefault);
                let query = Object.assign({}, this.$route.query);
                delete query.filter;

                this.$router.push({
                    name: this.$route.name,
                    params: this.$route.params,
                    query: Object.assign({}, query)
                });
                this.$root.$emit('refresh-table', 'cities');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// CitiesToolbar.vue?19317154